module.exports = __webpack_public_path__ + "static/media/WendellDavis.14e76ddf.jpg";